const SasbReportData = ({ data }) => {
    return (
        <>
            {
                data.map((curData, index) => {
                    const { question, year, supplier, category, answer, data } = curData;

                    return (
                        <tr key={index}>
                            <td>{supplier}</td>
                            <td>{year}</td>
                            <td>{category}</td>
                            <td>{question}</td>
                            <td>{answer} <div className="ms-2 me-auto last-child-red">
                                {data ? (
                                    <ul>
                                        {Object.entries(data).map(([key, value]) => (
                                            <div key={key}>
                                                <span > <b>{key}: </b> {value} </span>
                                            </div>
                                        ))}
                                    </ul>
                                ) : (
                                    '-'
                                )}
                            </div></td>
                            {/* <td ></td> */}
                            {/* <td>   <div class="ms-2 me-auto last-child-red">
                                {data && Object.keys(data).map((key) => (
                                    < span > <b>{key}: </b> {data[key]} </span>
                                ))}

                            </div></td> */}
                        </tr>
                    )
                })
            }
        </>
    )
}

export default SasbReportData;